export const QA_NAME_LISTING_CREATION_MODAL = 'createListing'

export const QA_NAME_LISTING_EDIT_MODAL = 'editListing'

export const LISTING_EDIT_MINIMIZED_SOURCE_ID_PREFIX = 'rental-portal-listing-'
